import React from "react";
const SvgDsScrollIcon = props => (
  <svg fill="none" viewBox="0 0 25 24" {...props}>
    <path
      fill="#1A1F24"
      fillRule="evenodd"
      d="M4.5 5.53V4h1v1.53h14V4h1v1.53c0 .556-.444 1-1 1h-14c-.556 0-1-.444-1-1zm0 3.92c0-.556.444-1 1-1h14c.556 0 1 .444 1 1v5.1c0 .556-.444 1-1 1h-14c-.556 0-1-.444-1-1v-5.1zm15 0h-14v5.1h14v-5.1zm-15 9.02c0-.556.444-1 1-1h14c.556 0 1 .444 1 1V20h-1v-1.53h-14V20h-1v-1.53z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDsScrollIcon;
